import { Route } from "react-router-dom";
import { CreateTask, CreateTaskFromProject, EditTask } from "../Tasks/Tasks";
import { TaskList, UsersTaskList } from "../Tasks/Table/TaskList";
import DragNDropTasks from "../Tasks/DragNDrop/DragNDropTasks";

export const TASK_ROUTES = [
    <Route key="tasks" path="/tasks" element={<TaskList />} />,
    <Route key="tasks-create" path="/tasks/create_task" element={<CreateTask />} />,
    <Route key="tasks-update" path="/tasks/update_task/:id" element={<EditTask />} />,
    <Route key="tasks-create-from-project" path="/tasks/create_task_from_project/:id" element={<CreateTaskFromProject />} />,
    <Route key="tasks-assign" path="/tasks/assign_tasks/:id?" element={<DragNDropTasks />} />,
    <Route key="tasks-personal" path="/tasks/personal" element={<UsersTaskList />} />
]
